import React, { useMemo } from "react";
import { Checkbox, FormControl, ListItemText, MenuItem, Select } from "@mui/material";
import { generateMonthOptions } from "./partnerAnalyticsUtils";

// Multi-select of "YYYY-MM" months, used in month-wise mode so a single
// partner can be compared across several months.
const MonthMultiSelect = ({ value = [], onChange, minWidth = "260px", max }) => {
	const monthOptions = useMemo(() => generateMonthOptions(18, 1), []);
	const labelByValue = useMemo(() => Object.fromEntries(monthOptions.map((o) => [o.value, o.label])), [monthOptions]);

	const renderValue = (selected) => {
		if (!selected?.length) return "Select month(s)";
		if (selected.length <= 2) return selected.map((v) => labelByValue[v] || v).join(", ");
		return `${selected.length} months selected`;
	};

	const handleChange = (e) => {
		const next = e.target.value;
		if (max && next.length > max) return;
		onChange(next);
	};

	return (
		<FormControl size="small" style={{ minWidth }}>
			<Select
				multiple
				displayEmpty
				value={value}
				onChange={handleChange}
				renderValue={renderValue}
				style={{
					background: "var(--bg-card)",
					borderRadius: "var(--radius-md)",
					fontWeight: "600",
				}}
			>
				{monthOptions.map((option) => (
					<MenuItem key={option.value} value={option.value}>
						<Checkbox checked={value.indexOf(option.value) > -1} size="small" />
						<ListItemText primary={option.label} />
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
};

export default MonthMultiSelect;
